import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		profileContainer: {
			alignItems: 'center',
			justifyContent: 'center',
		},
		profileMainContent: {
			maxWidth: '670px',
			width: '100%',
			marginTop: '30px',
			marginBottom: '30px',
			padding: '0px 10px',
		},
		sectionContent: {
			fontSize: '16px',
			color: '#929292',
			width: '100%',
		},
		textField: {
			width: '100%',
		},
		uploadBtn:{
			background: 'gray'
		}
	})
